import { automationsTranslations as en } from './en';
import { automationsTranslations as es } from './es';

import { createTranslationsHook } from '~/shared/i18n/createTranslationsHook';

export const useTranslations = createTranslationsHook({ en, es });

export type DefaultTranslations = typeof en;
